import { useTranslation } from 'react-i18next'
import { useFormContext, useWatch } from 'react-hook-form'

import { FieldSection } from '../../../formSection/fieldSection/FieldSection'
import { AddNewProgramFormModel } from '../../../AddNewProgram.types'

import { Checkbox } from '@percent/lemonade'

export function DynamicValidationSubmissionStatus() {
  const { t } = useTranslation()

  const { setValue, control } = useFormContext<AddNewProgramFormModel>()

  const [isDynamicValidationSubmissionStatus] = useWatch({
    control,
    name: ['isDynamicValidationSubmissionStatus']
  })

  return (
    <FieldSection>
      <Checkbox
        variant="default"
        active={isDynamicValidationSubmissionStatus}
        name="dynamicValidationSubmissionStatus"
        label={t('form.dynamicValidationSubmissionStatus')}
        onChange={() => {
          setValue('isDynamicValidationSubmissionStatus', !isDynamicValidationSubmissionStatus)
        }}
      />
    </FieldSection>
  )
}
